define(['magnificPopup'], function () {
    function PkPopup() {
        const translate = partyking.common.helpers.l.translate;
        const createChoice = (text, style, id, cb) => ({
            text,
            style,
            id,
            cb,
        });

        class Popup {
            constructor(html) {
                this.html = html;
                this.noScroll = false;
                this.type = 'inline';
                this.buttonText = 'Okej';
                this.popupOptions = {
                    fixedContentPos: false,
                    fixedBgPos: true,
                    overflowY: 'auto',
                    closeBtnInside: true,
                    preloader: false,
                    midClick: true,
                    removalDelay: 300,
                    mainClass: 'warning',
                };
            }

            useErrorOption() {
                this.popupOptions = {
                    ...this.popupOptions,
                    mainClass: 'error',
                };
            }

            overridePopupOption(options) {
                this.popupOptions = options;
            }

            addBtn(text, variant, id, margin = 'mt-4') {
                return `<button id=${id} class="${variant} ${margin}">${translate(text)}</button>`;
            }

            useVerticalButtonPlacementMargin(buttonId) {
                const button = document.getElementById(buttonId);
                button.classList.remove('mt-4');
                button.classList.add('mt-1');
            }

            layout(textArea, buttonArea) {
                return `<div class="mt-2"><div class='inline-scaler'><div class='text-center'>${textArea}</div>${buttonArea}</div></div>`;
            }

            placeVariable(variable, src, variableBefore) {
                if (variableBefore) return `${variable}${src}`;
                return `${src}${variable}`;
            }

            customVerticalPlacement(desktopMargin, mobileMargin) {
                const popup = document.getElementsByClassName('mfp-content')[0];
                popup.className = `mfp-content left-0 md:text-danger right-0 ml-auto mr-auto ${desktopMargin} ${mobileMargin}`;
                popup.style.position = 'absolute';

                return popup;
            }

            addTopArrow() {
                const arrowDivContainer = document.createElement('div');
                arrowDivContainer.className = 'w-full left-0 right-0 top-0 flex justify-center';
                arrowDivContainer.style.position = 'absolute';

                const arrowDiv = document.createElement('div');
                arrowDiv.className = 'w-0 h-0';
                arrowDiv.style.borderLeft = '8px solid transparent';
                arrowDiv.style.borderRight = '8px solid transparent';
                arrowDiv.style.borderBottom = '16px solid white';
                arrowDiv.style.marginTop = '-15px';
                arrowDivContainer.appendChild(arrowDiv);

                return arrowDivContainer;
            }

            useTopArrow(desktopMargin, mobileMargin) {
                const popup = this.customVerticalPlacement(desktopMargin, mobileMargin);

                popup.insertBefore(this.addTopArrow(), popup.firstChild);
            }

            createPopup(src) {
                const noScroll = this.noScroll;
                return {
                    ...this.popupOptions,
                    items: {
                        src: src,
                    },
                    type: 'inline',
                    callbacks: {
                        open: function () {
                            $('#close-button').on('click', function (event) {
                                $.magnificPopup.close();
                            });
                            if (typeof noScroll != 'undefined' && noScroll) {
                                $('body').css('overflow', 'hidden');
                                $('body').css('margin-right', '12px');
                            }
                        },
                        close: function () {
                            $('body').css('overflow', 'visible');
                            $('body').css('margin-right', '0px');
                        },
                    },
                };
            }

            render() {
                $.magnificPopup.open(this.createPopup(this.getSource()));
            }
        }

        class StaticPopup extends Popup {
            constructor(html) {
                super(html, true);
            }

            getSource() {
                return this.layout(this.html, this.addBtn(this.buttonText, 'w-full pk-button-yellow', 'close-button'));
            }
        }

        class ClaimsPopup extends StaticPopup {
            render() {
                $.magnificPopup.open(this.createPopup(this.getSource()));

                const closeButton = document.getElementById('close-button');
                removeEventListener('click', closeButton);
                closeButton.addEventListener('click', (event) => {
                    $.magnificPopup.close();
                });
            }
        }

        class DynamicPopup extends Popup {
            constructor(html, variable) {
                super(html, true);
                this.variable = variable;
            }

            getSource() {
                return this.layout(
                    this.placeVariable(this.variable, this.html, false),
                    this.addBtn(this.buttonText, 'w-full pk-button-yellow', 'close-button')
                );
            }
        }

        class ChoicePopup extends Popup {
            constructor(html, choices, withArrow, withVerticalButtonPlacement = true) {
                super(html, true);
                this.choices = choices;
                this.withArrow = withArrow;
                this.buttonPlacement = withVerticalButtonPlacement ? 'flex-col' : 'flex-row';
            }

            multiButtonPlacement() {
                return `<div class="flex w-full ${this.buttonPlacement}">
                ${this.choices.reduce((acc, choice) => {
                    if (acc == '') {
                        acc += this.addBtn(choice.text, choice.style, choice.id);
                    } else {
                        acc += this.addBtn(
                            choice.text,
                            choice.style,
                            choice.id,
                            this.buttonPlacement === 'row' ? '' : 'mt-2'
                        );
                    }
                    return acc;
                }, '')}
                </div>`;
            }

            getSource() {
                return this.layout(this.html, this.multiButtonPlacement(this.choices));
            }

            initCallbacks() {
                this.choices.forEach((choice) => {
                    if (choice.id) {
                        const btn = document.getElementById(choice.id);
                        const fn = () => {
                            $.magnificPopup.close();
                            if (choice.cb) choice.cb();
                            btn.removeEventListener('click', fn);
                        };
                        btn.addEventListener('click', fn);
                    }
                });
            }

            render() {
                super.render();
                this.initCallbacks();

                if (this.withArrow) this.useTopArrow('top-20', 'lg:top-14');
            }
        }

        return {
            StaticPopup,
            DynamicPopup,
            ChoicePopup,
            ClaimsPopup,
            createChoice,
        };
    }
    return PkPopup;
});
